import { cn }  from "@/lib/utils"
import { Input } from "@/components/ui/input"
import {ChangeEvent, useRef} from "react";

interface SearchBarProps {
    className?: string,
    label: string,
    onInput?: (event: ChangeEvent<HTMLInputElement>) => void,
    isSelected?: (value: boolean) => void;
    icon?: string;
    onIconClick?: () => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    inputValue: string;
}

const SearchBar = ({ className, label, onInput, isSelected, icon = "search", onIconClick, onFocus, onKeyDown, inputValue }: SearchBarProps) => {
    const inputRef = useRef(null);

    function handleFocus(event: React.FocusEvent<HTMLInputElement> ) {
        if(event.target === document.activeElement && isSelected) isSelected(true);
    }

    function handleBlur(event: React.FocusEvent<HTMLInputElement> ) {
        if(isSelected) isSelected(false);
    }

    function handleIconClick() {
        // @ts-ignore
        if(inputRef.current) inputRef.current.value = "";
        onIconClick && onIconClick();
    }

    return (

        <div className={cn('search py-3', className)}>
            <Input
                value={inputValue}
                ref={inputRef}
                placeholder={label}
                icon={icon}
                onInput={onInput}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onIconClick={handleIconClick}
                onFocusCapture={onFocus}
                onKeyDown={onKeyDown}
            />
        </div>
    )
}

export { SearchBar }
